import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  MaterialReactTable,
  useMaterialReactTable,
  createMRTColumnHelper,
  type MRT_ColumnDef,
} from 'material-react-table';

import {
  Box,
  Button,
  ListItemIcon,
  MenuItem,
  Tooltip,
  Typography,
  lighten,
} from '@mui/material';

import { AdminRegistryTableData } from '../../../interface/IAdminRegistry';

import helperIndex from '../../../helpers/index';


import iconEdit from '../../../assets/edit-icon.png';
import iconDelete from '../../../assets/delete.png';


import adminRegistryService from '../../../pages/AdminRegistry/adminRegistryService';

//example data type


const columnHelper = createMRTColumnHelper<AdminRegistryTableData>();

interface AdminRegistryTableProps {
  data: AdminRegistryTableData[];
  deleteAdminButtonClick: (username: string) => void;
  isReadOnly: boolean;
}


const AdminRegistryTable: React.FC<AdminRegistryTableProps> = ({ data, deleteAdminButtonClick, isReadOnly }) => {

  const navigate = useNavigate();

  function UpdateAdminButtonClick(param: string) {
    navigate('/Admin/UpdateAdmin/' + param);

  }


  //should be memoized or stable
  const columns = useMemo<MRT_ColumnDef<AdminRegistryTableData>[]>(
    () => [
      {
        accessorFn: (row: AdminRegistryTableData) => `${row.firstname} ${row.lastname}`,
        id: 'fullName',
        header: 'Full Name',
        enableSorting: true
      },
      {
        accessorKey: 'userId',
        header: 'ID',
        enableSorting: true
      },
      {
        accessorKey: 'username',
        header: 'Username'
      },
      {
        accessorKey: 'email', //normal accessorKey
        header: 'Email',
        size: 200,
      },
      {
        accessorFn: (row: AdminRegistryTableData) => helperIndex.formatLongDate(new Date(row.createdDateTime)),
        header: 'Date Registered',
        size: 150,
        sortingFn: (rowA, rowB) => {
          const firstData = new Date(rowA.original.createdDateTime || new Date()).getTime() || 0;
          const secondData = new Date(rowB.original.createdDateTime || new Date()).getTime() || 0;
          // Perform numeric comparison
          return Number(firstData) - Number(secondData);
        }
      },
      {
        header: 'Actions',
        Cell: ({ renderedCellValue, row }) => (
          <Box className='table-btn'>
            <Tooltip title="Edit Permission">
              <Button
                disabled={isReadOnly}
                className="btn-icon-1"
                onClick={() => UpdateAdminButtonClick(row.original.username)}
              >
                <img className='responsive-image' src={iconEdit} />
              </Button>
            </ Tooltip>
            <Tooltip title="Delete">
              <Button
                disabled={isReadOnly}
                className="btn-icon-1"
                onClick={() => deleteAdminButtonClick(row.original.username)}
              >
                <img className='responsive-image' src={iconDelete} />
              </Button>
            </Tooltip>
          </Box>
        )
      }
    ],
    [isReadOnly],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    enableColumnActions: false,
    muiTablePaperProps: {
      elevation: 1,
      sx: {
        boxShadow: 'none',
        width: '100%',
        background: 'transparent',
        display: 'grid',

      }
    }
  });

  return <MaterialReactTable table={table} />;
};

export default AdminRegistryTable;
